import React from 'react';
import { motion } from 'framer-motion';
import { Package } from 'lucide-react';

const MysteryBox = ({ isShaking, onClick }) => {
  return (
    <motion.div
      data-testid="mystery-box"
      className={`relative w-64 h-64 cursor-pointer ${
        isShaking ? 'animate-shake' : ''
      }`}
      onClick={onClick}
      animate={!isShaking ? { y: [0, -20, 0] } : {}}
      transition={!isShaking ? { duration: 4, repeat: Infinity, ease: 'easeInOut' } : {}}
      whileHover={{ scale: 1.1 }}
      whileTap={{ scale: 0.95 }}
    >
      {/* Box Container */}
      <div className="relative w-full h-full flex items-center justify-center">
        {/* Glow Effect */}
        <div
          className="absolute inset-0 rounded-3xl blur-3xl"
          style={{
            background: 'radial-gradient(circle, rgba(255,0,255,0.4) 0%, rgba(0,255,153,0.2) 50%, transparent 70%)',
          }}
        />

        {/* Box */}
        <div className="relative z-10 w-full h-full bg-gradient-to-br from-[#1a1a1a] to-[#0a0a0a] rounded-3xl border-4 border-white/10 flex items-center justify-center overflow-hidden">
          {/* Question Mark Pattern */}
          <div className="absolute inset-0 opacity-5">
            <div className="text-[200px] font-anton text-white absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2">?</div>
          </div>

          {/* Icon */}
          <Package
            className="w-32 h-32 text-neon-pink drop-shadow-[0_0_20px_rgba(255,0,255,0.6)]"
            strokeWidth={1.5}
          />
        </div>

        {/* Corner Accents */}
        <div className="absolute top-0 left-0 w-8 h-8 border-t-4 border-l-4 border-neon-green rounded-tl-2xl" />
        <div className="absolute top-0 right-0 w-8 h-8 border-t-4 border-r-4 border-neon-green rounded-tr-2xl" />
        <div className="absolute bottom-0 left-0 w-8 h-8 border-b-4 border-l-4 border-neon-green rounded-bl-2xl" />
        <div className="absolute bottom-0 right-0 w-8 h-8 border-b-4 border-r-4 border-neon-green rounded-br-2xl" />
      </div>
    </motion.div>
  );
};

export default MysteryBox;